import { SVGProps, Ref, forwardRef } from 'react'
const SvgFileUpload = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.002 23.251v-15M16.502 12.751l-4.5-4.5-4.5 4.5"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.252 19.5H6a3 3 0 0 1-3-3V3.751a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3V16.5a3 3 0 0 1-3 3h-2.25"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgFileUpload)
export default ForwardRef
